import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.benchmarkData`;
export const INIT = `${SCOPE}/INIT`;

export const SETUP_DIMENSION = `${SCOPE}/SETUP_DIMENSION`;
export const UNSET_DIMENSION = `${SCOPE}/UNSET_DIMENSION`;

export const INIT_BENCHMARK = `${SCOPE}/INIT_BENCHMARK`;
export const SET_RESPONSE = `${SCOPE}/SET_RESPONSE`;

export const INIT_BENCHMARK_SPI = `${SCOPE}/INIT_BENCHMARK_SPI`;

export const IMP_BENCHMARK_KPI = `${SCOPE}/IMP_BENCHMARK_KPI`;
export const IMP_BENCHMARK_SPI = `${SCOPE}/IMP_BENCHMARK_SPI`;
export const BENCHMARK_DATA = `${SCOPE}/BENCHMARK_DATA`;
export const SUPPORTED_METRICS = `${SCOPE}/BENCHMARK_SUPPORTED_METRICS`;
